import React, { createContext, useCallback, useContext, useMemo } from 'react';

type QMenuCloseContextValue = {
  close: () => void;
};

const QMenuCloseContext = createContext<QMenuCloseContextValue | null>(null);

/**
 * Root-menu dismiss API for {@link QMenuItem} auto-close.
 * Provided by {@link QMenu}; nested {@link QMenuSub} portals still inherit this context.
 */
export function QMenuCloseProvider({
  onClose,
  children,
}: {
  onClose: () => void;
  children: React.ReactNode;
}): React.ReactElement {
  const close = useCallback(() => {
    onClose();
  }, [onClose]);
  const value = useMemo(() => ({ close }), [close]);
  return <QMenuCloseContext.Provider value={value}>{children}</QMenuCloseContext.Provider>;
}

export function useQMenuClose(): QMenuCloseContextValue | null {
  return useContext(QMenuCloseContext);
}
